/**
 * La sesión que supabase-js dejó en el aparato, leída sin esperar a nadie (y sin
 * red). Módulo puro: lo usan el arranque y `AuthContext`.
 */
const CLAVE_DE_SESION = /^sb-.+-auth-token(\.\d+)?$/;

export interface SesionGuardada {
  access_token?: string;
  refresh_token?: string;
  expires_at?: number;
  user: { id: string; email?: string; [k: string]: unknown };
  [k: string]: unknown;
}

/** La sesión que supabase-js dejó en `localStorage`, tal cual, o null. Sin red. */
export function sesionGuardada(): SesionGuardada | null {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const clave = localStorage.key(i);
      if (!clave || !CLAVE_DE_SESION.test(clave)) continue;
      const valor = localStorage.getItem(clave);
      if (!valor || valor.length < 20) continue;
      const s = JSON.parse(valor) as SesionGuardada | { currentSession?: SesionGuardada };
      const sesion = "user" in s ? (s as SesionGuardada) : (s as { currentSession?: SesionGuardada }).currentSession;
      if (sesion?.user?.id) return sesion;
    }
  } catch {
    /* almacenamiento bloqueado o JSON roto: como si no hubiera sesión */
  }
  return null;
}

